export const checkFileType = (file, requiredFileType) => {
  if (requiredFileType.match(file.type) || file.type === requiredFileType) {
    return null
  }

  return `Le fichier (${file.type}) n'est pas de type ${requiredFileType}`
}
